<template>
  <div class="row">
    <div class="col-12">
      <div class="kt-section kt-section--first">
        <div class="row">
          <div class="col-md-4 col-lg-3">
            <div class="kt-section__title">
              Default Item Image
            </div>
            <default-image-uploader type="item" />
          </div>
          <div class="col-md-4 col-lg-3">
            <div class="kt-section__title">
              Default Feed Image
            </div>
            <default-image-uploader type="feed" />
          </div>
        </div>
      </div>

      <div v-perms="['recording']" class="kt-section kt-section--first">
        <div class="kt-section__title">
          Recording Defaults
        </div>
        <div class="kt-section__body">
          <div class="form-group">
            <div class="form-group">
              <duration-picker v-model="rec_duration_obj"
                               label="Set default recording duration. Note: Individual setting for each user!"
                               :days="false"
                               :seconds="false" />
              <button class="btn btn-ss-standout mt-2" @click="() => generalUpdate('quick_record_duration', durationObjToUnit(rec_duration_obj) / 60, 'user')">
                Save
              </button>
            </div>
          </div>
        </div>
      </div>

      <div v-perms="['scheduler']" class="kt-section">
        <div class="kt-section__title">
          Scheduler Defaults
        </div>
        <div class="kt-section__body">
          <div class="form-group">
            <duration-picker v-model="scheduler_publish_duration_obj"
                             label="Set default scheduler publish duration (recurring events only) after broadcast end of recordings being done via Timbre user interface. Set all values to 0 to publish forever."
                             :seconds="true" />
            <button class="btn btn-ss-standout mt-2" @click="() => generalUpdate('scheduler_publish_duration', durationObjToUnit(scheduler_publish_duration_obj, 'seconds'))">
              Save
            </button>
          </div>
          <div class="form-group">
            <duration-picker v-model="scheduler_publish_duration_epg_obj"
                             label="Set global scheduler publish duration after broadcast end of recordings being done via EPG or 3rd party provider. Set all values to 0 to publish forever."
                             :seconds="true" />
            <button class="btn btn-ss-standout mt-2" @click="() => generalUpdate('scheduler_publish_duration_epg', durationObjToUnit(scheduler_publish_duration_epg_obj, 'seconds'))">
              Save
            </button>
          </div>
          <div class="form-group">
            <duration-picker v-model="timbre_scheduler_offset_obj"
                             label="Set global scheduler offset for recordings being done via Timbre user interface."
                             :seconds="true" />
            <button class="btn btn-ss-standout mt-2" @click="() => generalUpdate(`scheduler_offset`, durationObjToUnit(timbre_scheduler_offset_obj, 'seconds'))">
              Save
            </button>
          </div>
          <div class="form-group">
            <duration-picker v-model="epg_scheduler_offset_obj"
                             label="Set global scheduler offset for recordings being done via EPG or 3rd party provider."
                             :seconds="true" />
            <button class="btn btn-ss-standout mt-2" @click="() => generalUpdate(`scheduler_offset_epg`, durationObjToUnit(epg_scheduler_offset_obj, 'seconds'))">
              Save
            </button>
          </div>
        </div>
      </div>

      <div class="kt-section">
        <div class="kt-section__title">
          Feed Defaults
        </div>
        <div class="kt-section__body">
          <div class="form-group">
            <label>Default Feed Owner (name)</label>
            <div class="input-group">
              <input v-model="feed_owner" type="text" class="form-control">
              <div class="input-group-append">
                <button class="btn btn-ss-standout" @click="generalUpdate('feed_owner', feed_owner)">
                  Save
                </button>
              </div>
            </div>
            <span class="form-text text-muted" />
          </div>
          <div class="form-group">
            <label>Default Feed Email</label>
            <div class="input-group">
              <input v-model="feed_email" type="text" class="form-control">
              <div class="input-group-append">
                <button class="btn btn-ss-standout" @click="generalUpdate('feed_email', feed_email)">
                  Save
                </button>
              </div>
            </div>
            <span class="form-text text-muted" />
          </div>
        </div>
      </div>

      <div class="kt-section">
        <div class="kt-section__title">
          Item Defaults
        </div>
        <div class="kt-section__body">
          <div class="form-group">
            <div class="d-flex flex-column">
              <ss-checkbox id="default-download" v-model="default_download">
                Downloadable
              </ss-checkbox>
              <ss-checkbox id="default-publish" v-model="default_publish">
                Published
              </ss-checkbox>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-12 col-md-6">
              <label>Default Copyright</label>
              <div class="input-group">
                <input v-model="item_copyright_default" type="text" class="form-control">
                <div class="input-group-append">
                  <button class="btn btn-ss-standout" type="button" @click="updateCopyright()">
                    Save
                  </button>
                </div>
              </div>
              <span class="form-text text-muted">Default copyright for your items. Used in metadata and {{ getFeedLabel() }}s</span>
            </div>
          </div>
        </div>
      </div>

      <div class="kt-section">
        <div class="kt-section__title">
          User Overrides
        </div>
        <div class="kt-section__body">
          <div class="form-group row">
            <div class="col-12 col-md-6">
              <label>Timezone</label>
              <timezone-picker wrapper-class="input-group" />
              <span class="form-text text-muted">Unless otherwise specified, your timezone will default to your current location</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DurationPicker from 'VueComponents/DurationPicker';
import TimezonePicker from 'VuePartials/TimezonePicker';
import DefaultImageUploader from "VuePartials/App/Preferences/DefaultImageUploader";

export default {
  components: {
    DurationPicker,
    TimezonePicker,
    DefaultImageUploader,
  },
  data: () => ({
    show_rec_duration_silder: false,
    show_publish_duration_slider: false,
    show_scheduler_offset_epg_slider: false,
    show_scheduler_offset_slider: false,
    default_download: window.preferences.default_download,
    default_publish: window.preferences.default_publish,
    rec_duration: window.preferences.quick_record_duration,
    scheduler_publish_duration: window.preferences.scheduler_publish_duration,
    scheduler_offset_epg: window.preferences.scheduler_offset_epg,
    schedulerOffsetForm: window.preferences.scheduler_offset,
    item_copyright_default: window.preferences.copyright,
    feed_email: window.preferences.feed_email,
    feed_owner: window.preferences.feed_owner,
    rec_duration_obj: {
      minutes: window.preferences.quick_record_duration,
    },
    // default publish duration for schedules coming from Timbre UI
    scheduler_publish_duration_obj: {
      seconds: window.preferences.scheduler_publish_duration,
    },
    // default publish duration for schedules coming from 3rd party epg
    scheduler_publish_duration_epg_obj: {
      seconds: window.preferences.scheduler_publish_duration_epg,
    },
    epg_scheduler_offset_obj: {
      seconds: window.preferences.scheduler_offset_epg,
    },
    timbre_scheduler_offset_obj: {
      seconds: window.preferences.scheduler_offset,
    },
  }),
  watch: {
    default_download(val) {
      this.$nextTick(() => {
        this.updateDefaultDownload(val);
      });
    },
    default_publish(val) {
      this.$nextTick(() => {
        this.updateDefaultPublish(val);
      });
    },
  },

  mounted() {
    // Workaround/hack to properly display sliders positions (runs once)
    $('#default_config_accordion_content').one('show.bs.collapse', () => {
      this.show_rec_duration_silder = true;
      this.show_publish_duration_slider = true;
      this.show_scheduler_offset_epg_slider = true;
      this.show_scheduler_offset_slider = true;
    });
  },

  methods: {
    async generalUpdate(col, val, level) {
      try {
        const response = await axios.patch(
          `/api/v1/user/preference/update`,
          {
            col: col,
            val: val,
            level: level ?? 'customer',
          },
        );

        if (response.data.success) {
          toastr.success(`${col} updated to : ${val}`);
        }
      } catch (error) {
        toastr.error(`Failed to update ${col}`);
      }
    },
    updateCopyright: _.debounce(async function () {
      try {
        const response = await axios.patch(
          `/api/v1/user/preference/update`,
          {
            col: "copyright",
            val: this.item_copyright_default,
          },
        );

        if (response.data.success) {
          toastr.success(`Default copyright updated to : ${this.item_copyright_default}`);
        }
      } catch (error) {
        toastr.error("Failed to update default copyright!");
      }
    }, 1000),

    updateDefaultDownload: _.debounce(async (default_download) => {
      try {
        const response = await axios.patch(
          `/api/v1/user/preference/update`,
          {
            col: "default_download",
            val: default_download,
          },
        );
        if (response.data.success) {
          if (default_download) {
            toastr.success("Items will now be downloadable by default!");
          } else {
            toastr.success("Items will now be not downloadable by default!");
          }
        }
      } catch (error) {
        toastr.error("Failed to update downloadable value!");
      }
    }, 1000),

    updateDefaultPublish: _.debounce(async (default_publish) => {
      try {
        const response = await axios.patch(
          `/api/v1/user/preference/update`,
          {
            col: "default_publish",
            val: default_publish,
          },
        );
        if (response.data.success) {
          if (default_publish) {
            toastr.success("Items will now be published by default!");
          } else {
            toastr.success("Items will now are now be unpublished by default!");
          }
        }
      } catch (error) {
        toastr.error("Failed to update downloadable value!");
      }
    }, 1000),

  },
};
</script>

<style lang="scss" scoped>
 .multiselect--active {
      z-index: 1000;
  }
</style>
